<div *ngIf="aircraftProfileSkeletonLoading$ | async">Loading...</div>
<div *ngIf="aircraftProfileSkeletonLoaded$ | async">
  <mat-accordion *ngIf="aircraftProfileSkeleton$ | async as aircraftProfileSkeleton">
    <mat-expansion-panel (opened)="aircraftProfileOpened(aircraftProfileSkeleton)">
      <mat-expansion-panel-header> Aircraft Profile </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <sd-portal-aircraft-profile-audit-list
          #aircraftProfileAuditList
          [aircraftProfileId]="aircraftProfileSkeleton.aircraftProfileId"
          [loading]="aircraftProfileAuditsLoading$ | async"
          [aircraftProfileAudits]="aircraftProfileAudits$ | async"
          (nextPage)="nextProfileAuditPage($event)"
          (loadAircraftProfile)="loadProfileAudits($event)"
        >
        </sd-portal-aircraft-profile-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="colorSettingOpened(aircraftProfileSkeleton.colorSetting)">
      <mat-expansion-panel-header> Color Setting </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <sd-portal-color-setting-audit-list
          #colorSettingAuditList
          [colorSettingId]="aircraftProfileSkeleton.colorSetting.colorSettingId"
          [loading]="colorSettingAuditsLoading$ | async"
          [colorSettingAudits]="colorSettingAudits$ | async"
          (nextPage)="nextColorSettingAuditPage($event)"
          (loadColorSetting)="loadColorSettingAudits($event)"
        ></sd-portal-color-setting-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="aircraftPerformanceOpened(aircraftProfileSkeleton.aircraftPerformance)"
    >
      <mat-expansion-panel-header> Aircraft Performance </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <sd-portal-performance-audit-list
          #aircraftPerformanceAuditList
          [aircraftPerformanceId]="
            aircraftProfileSkeleton.aircraftPerformance.aircraftPerformanceId
          "
          [loading]="aircraftPerformanceAuditsLoading$ | async"
          [aircraftPerformanceAudits]="aircraftPerformanceAudits$ | async"
          (nextPage)="nextAircraftPerformanceAuditPage($event)"
          (loadAircraftPerformance)="loadAircraftPerformanceAudits($event)"
        ></sd-portal-performance-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Engines </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="
              let aircraftProfileEngine of aircraftProfileSkeleton.aircraftProfileEngines
                | uniqBy : 'engine.engineId'
            "
            (opened)="engineOpened(aircraftProfileEngine)"
          >
            <mat-expansion-panel-header>{{
              aircraftProfileEngine.engine.name
            }}</mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <sd-portal-engine-audit-list
                #engineAuditList
                [aircraftProfileEngineId]="aircraftProfileEngine.aircraftProfileEngineId"
                [loading]="
                  (aircraftProfileEngineAuditsLoading$ | async) && (engineAuditsLoading$ | async)
                "
                [aircraftProfileEngineAudits]="aircraftProfileEngineAudits$ | async"
                [engineId]="aircraftProfileEngine.engine.engineId"
                [engineAudits]="engineAudits$ | async"
                (nextPage)="nextEngineAuditPage($event)"
                (loadEngine)="loadEngineAudits($event)"
              ></sd-portal-engine-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Aircraft Engines Relation</mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let aircraftProfileEngine of aircraftProfileSkeleton.aircraftProfileEngines"
            (opened)="engineOpened(aircraftProfileEngine)"
          >
            <mat-expansion-panel-header>
              {{ aircraftProfileEngine.engine.name }}
              {{ aircraftProfileEngine.attachedStartDate | momentDate : 'MM/DD/YYYY' }} -
              {{
                aircraftProfileEngine.attachedStoppedDate
                  ? (aircraftProfileEngine.attachedStoppedDate | momentDate : 'MM/DD/YYYY')
                  : 'ATTACHED'
              }}
            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <sd-portal-engine-audit-list
                #engineAuditList
                [aircraftProfileEngineId]="aircraftProfileEngine.aircraftProfileEngineId"
                [loading]="
                  (aircraftProfileEngineAuditsLoading$ | async) && (engineAuditsLoading$ | async)
                "
                [aircraftProfileEngineAudits]="aircraftProfileEngineAudits$ | async"
                [engineId]="aircraftProfileEngine.engine.engineId"
                [engineAudits]="engineAudits$ | async"
                (nextPage)="nextEngineAuditPage($event)"
                (loadEngine)="loadEngineAudits($event)"
              ></sd-portal-engine-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Components </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="
              let aircraftProfileComponent of aircraftProfileSkeleton.aircraftProfileComponents
            "
            (opened)="componentOpened(aircraftProfileComponent)"
          >
            <mat-expansion-panel-header>{{
              aircraftProfileComponent.component.name
            }}</mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <sd-portal-component-audit-list
                #componentAuditList
                [aircraftProfileComponentId]="aircraftProfileComponent.aircraftProfileComponentId"
                [loading]="
                  (aircraftProfileComponentAuditsLoading$ | async) &&
                  (componentAuditsLoading$ | async)
                "
                [aircraftProfileComponentAudits]="aircraftProfileComponentAudits$ | async"
                [componentId]="aircraftProfileComponent.component.componentId"
                [componentAudits]="componentAudits$ | async"
                (nextPage)="nextComponentAuditPage($event)"
                (loadComponent)="loadComponentAudits($event)"
              ></sd-portal-component-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="aircraftRelationTypesLoaded$ | async">
      <mat-expansion-panel-header> Owners/Operators/Lessees </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <ng-container *ngIf="aircraftRelationTypes$ | async as aircraftRelationTypes">
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="let aircraftRelation of aircraftProfileSkeleton.aircraftRelations"
              (opened)="aircraftRelationOpened(aircraftRelation)"
            >
              <mat-expansion-panel-header
                >{{
                  getAircraftRelationTypeName(
                    aircraftRelationTypes,
                    aircraftRelation.aircraftRelationType
                  )
                }}
                - {{ aircraftRelation.name }}</mat-expansion-panel-header
              >

              <ng-template matExpansionPanelContent>
                <sd-portal-aircraft-relation-audit-list
                  #aircraftRelationAuditList
                  [aircraftRelation]="aircraftRelation"
                  [aircraftRelationAudits]="aircraftRelationAudits$ | async"
                  [loading]="aircraftRelationAuditsLoading$ | async"
                  [phoneNumberAudits]="phoneNumberAudits$ | async"
                  [phoneNumberAuditsLoading]="phoneNumberAuditsLoading$ | async"
                  [faxNumberAudits]="faxNumberAudits$ | async"
                  [faxNumberAuditsLoading]="faxNumberAuditsLoading$ | async"
                  [emailAddressAudits]="emailAddressAudits$ | async"
                  [emailAddressAuditsLoading]="emailAddressAuditsLoading$ | async"
                  [addressAudits]="addressAudits$ | async"
                  [addressAuditsLoading]="addressAuditsLoading$ | async"
                  (nextPage)="nextAircraftRelationAuditPage($event)"
                  (loadAircraftRelation)="loadAircraftRelationAudits($event)"
                  (nextPhoneNumberPage)="nextPhoneNumberAuditPage($event)"
                  (loadPhoneNumber)="loadPhoneNumberAudits($event)"
                  (nextFaxNumberPage)="nextFaxNumberAuditPage($event)"
                  (loadFaxNumber)="loadFaxNumberAudits($event)"
                  (nextEmailAddressPage)="nextEmailAddressAuditPage($event)"
                  (loadEmailAddress)="loadEmailAddressAudits($event)"
                  (nextAddressPage)="nextAddressAuditPage($event)"
                  (loadAddress)="loadAddressAudits($event)"
                ></sd-portal-aircraft-relation-audit-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="postFlightVisibilityTypesLoaded$ | async">
      <mat-expansion-panel-header>
        Postflight Visibilities Configuration
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let postFlightVisibility of aircraftProfileSkeleton.postFlightVisibilities"
            (opened)="postFlightVisibilityOpened(postFlightVisibility)"
          >
            <mat-expansion-panel-header
              *ngIf="postFlightVisibilityTypes$ | async as postFlightVisibilityTypes"
            >
              {{
                getPostFlightVisibilityTypeName(
                  postFlightVisibilityTypes,
                  postFlightVisibility.postFlightVisibilityTypeId
                )
              }}
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-postflight-visibility-audit-list
                #postFlightVisibilityAuditList
                [postFlightVisibilityId]="postFlightVisibility.postFlightVisibilityId"
                [loading]="postFlightVisibilityAuditsLoading$ | async"
                [postFlightVisibilityAudits]="postFlightVisibilityAudits$ | async"
                (nextPage)="nextPostFlightVisibilityAuditPage($event)"
                (loadPostFlightVisibility)="loadPostFlightVisibilityAudits($event)"
              ></sd-portal-postflight-visibility-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Aircraft Billing Rates </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let billingRate of aircraftProfileSkeleton.aircraftBillingRates"
            (opened)="aircraftBillingRateOpened(billingRate)"
          >
            <mat-expansion-panel-header>
              {{ billingRate.rate | currency }} /
              {{ getAircraftBillingRateTypeName(billingRate.rateType) }}
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-aircraft-billing-rate-audit-list
                #aircraftBillingRateAuditList
                [aircraftBillingRateId]="billingRate.aircraftBillingRateId"
                [loading]="aircraftBillingRateAuditsLoading$ | async"
                [aircraftBillingRateAudits]="aircraftBillingRateAudits$ | async"
                (nextPage)="nextAircraftBillingRateAuditPage($event)"
                (loadAircraftBillingRate)="loadAircraftBillingRateAudits($event)"
              ></sd-portal-aircraft-billing-rate-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
